import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  Assignment,
  AssignmentAttempt,
  AssignmentList,
  AssignmentTrackerFooter
} from './components';

const AssignmentTracker = () => {
  const location = useLocation();

  const getContent = () => {
    if (location.pathname.includes('students')) return <AssignmentAttempt />;
    if (location.pathname.includes('assignments')) return <Assignment />;

    return <AssignmentList />;
  };

  return (
    <>
      {getContent()}
      <AssignmentTrackerFooter />
    </>
  );
};

export default AssignmentTracker;
